import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { Trans } from "@lingui/macro";
import { Container, Spinner, Table, Typography } from "@ster/ster-toolkit";
import { formatDistanceToNow } from "date-fns";
import { memo, useEffect, useState } from "react";

import { useLazyGetApiV1AccountUsersForOrganisationQuery } from "../../store/coreApi";
import { isDateTimeMinValue } from "../../utils/dateHelper";
import styles from "./OrganisationUsers.module.less";

const OrganisationUsers = memo(
  ({ organisationCode }: { organisationCode: string }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const [
      fetchUsers,
      { data: organisationUsers, isLoading: isOrganisationUsersLoading },
    ] = useLazyGetApiV1AccountUsersForOrganisationQuery();

    useEffect(() => {
      if (isExpanded) {
        fetchUsers({ organisationCode });
      }
    }, [isExpanded, organisationCode, fetchUsers]);

    const mappedUsers = organisationUsers?.map((user) => ({
      ...user,
      fullName: user.userInfo?.fullName,
    }));

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };

    return (
      <Container>
        <div
          className={styles.tableHeader}
          onClick={toggleExpand}
          role="button"
          tabIndex={0}
        >
          <Typography.Title level={2}>
            <Trans>Gebruikers van huidige organisatie</Trans>
          </Typography.Title>
          <Typography.Title level={2} style={{ marginTop: "0" }}>
            {isExpanded ? <DownOutlined /> : <RightOutlined />}
          </Typography.Title>
        </div>

        {isExpanded && (
          <Spinner spinning={isOrganisationUsersLoading}>
            <Table
              pagination={false}
              rowKey="id"
              columns={[
                {
                  title: <Trans>Naam</Trans>,
                  key: "fullName",
                  dataIndex: "fullName",
                },
                {
                  title: <Trans>E-mail</Trans>,
                  key: "email",
                  dataIndex: "email",
                },
                {
                  title: <Trans>Laatst ingelogd op</Trans>,
                  key: "lastLogin",
                  dataIndex: "lastLogin",
                  render: (value) =>
                    value && !isDateTimeMinValue(value) ? (
                      formatDistanceToNow(new Date(value), { addSuffix: true })
                    ) : (
                      <Trans>Nog niet ingelogd</Trans>
                    ),
                },
                {
                  title: <Trans>Actief</Trans>,
                  key: "active",
                  dataIndex: "active",
                  render: (value) =>
                    value ? <Trans>Ja</Trans> : <Trans>Nee</Trans>,
                },
              ]}
              dataSource={mappedUsers}
            />
          </Spinner>
        )}
      </Container>
    );
  }
);

export default OrganisationUsers;
